module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t-20"
  }, [_c('div', {
    staticClass: "ovf-hd"
  }, [_c('div', {
    staticClass: "fl"
  }, [_vm._v("列表配置")]), _vm._v(" "), _c('div', {
    staticClass: "fl m-l-20"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addCol()
      }
    }
  }, [_vm._v("添加列")]), _vm._v(" "), (_vm.hasImport) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.showImport
    }
  }, [_vm._v("批量导入")]) : _vm._e(), _vm._v(" "), (!_vm.isSimple) ? _c('el-button', {
    staticClass: "m-l-10",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setSortConfig()
      }
    }
  }, [_vm._v("展示数据配置")]) : _vm._e(), _vm._v(" "), _vm._t("default")], true)]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 table-container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "show_name",
      "label": "列名称",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "字段名",
      "width": "150"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.getFieldName(scope.row.field_id)) + "\n          ")]
      }
    }
  }), _vm._v(" "), (!_vm.isSimple) ? _c('el-table-column', {
    attrs: {
      "label": "权限"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.rule.name))])]
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setConfig(scope.$index, scope.row)
            }
          }
        }, [_vm._v("配置")]), _vm._v(" "), (scope.$index != 0) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.moveTr(scope.$index, 0)
            }
          }
        }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (scope.$index != _vm.tableData.length - 1) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.moveTr(scope.$index, 1)
            }
          }
        }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.deleteCol(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f46bac4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/listTable.vue
// module id = 1911
// module chunks = 2